<template>
  <div class="dialogCauHinhLuong update_Line">
    <!-- header -->
    <div class="dialog-header flex-row flex__between">
      <h3 class="dialog-title">Cấu hình luồng</h3>
      <i
        class="btn-close__large el-icon-circle-close clickable"
        @click="modelBack"
      ></i>
    </div>
    <!-- end_header -->

    <!-- body -->
    <VuePerfectScrollbar class="scroll-CapNhatLuong">
      <div class="dialog-body">
        <el-form :model="form" ref="form" label-position="top" :disabled="true">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Tên luồng" prop="flowName">
                <el-input
                  v-model="form.flowName"
                  placeholder="Tên luồng"
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  size="medium"
                  maxlength="150"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Mã" prop="flowCode">
                <el-input
                  v-model="form.flowCode"
                  placeholder="Mã"
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  size="medium"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Loại quy trình" prop="flowType">
                <el-input
                  v-model="form.flowTypeName"
                  placeholder="Mã"
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  size="medium"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Cấp quy trình" prop="deptId">
                <el-input
                  v-model="form.deptName"
                  placeholder="Mã"
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  size="medium"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Ghi chú" prop="note">
                <el-input
                  type="textarea"
                  v-model="form.note"
                  placeholder="Mã"
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  size="medium"
                  maxlength="50"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 5 }"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Mặc định" prop="isDefault">
                <el-checkbox
                  :border="false"
                  v-model="form.isDefault"
                  class="style-fullWidth"
                >
                </el-checkbox>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Hoạt động" prop="status">
                <el-checkbox
                  :border="false"
                  v-model="form.status"
                  class="style-fullWidth"
                >
                </el-checkbox>
              </el-form-item>
            </el-col>

            <!--            <el-col :span="12" v-if="isIncomingFlow">-->
            <!--              <el-form-item label="Ẩn ý kiến VT" prop="hideVtComments">-->
            <!--                <el-checkbox-->
            <!--                  :border="false"-->
            <!--                  v-model="form.hideVtComments"-->
            <!--                  class="style-fullWidth"-->
            <!--                >-->
            <!--                </el-checkbox>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
          </el-row>
        </el-form>
      </div>
    </VuePerfectScrollbar>

    <!-- end body -->

    <!-- footer -->
    <div class="dialog-footer submit-area">
      <el-button size="medium" type="primary" @click="editVbFlowForm">
        <i class="far fa-check-circle font-size__small"></i>
        &nbsp;Sửa
      </el-button>

      <el-button size="medium" type="primary" @click="submit">
        <i class="far fa-check-circle font-size__small"></i>
        &nbsp;Lưu
      </el-button>
    </div>
    <!-- end_footer -->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../../constants";
import cauHinhLuongUtils from "../../../services/cauhinhluong/cauHinhLuongUtils";
import departmentService from "../../../services/departmentService";

export default {
  props: ["vbFlowForm"],
  components: {VuePerfectScrollbar},

  data() {
    return {
      perfectScrollbarSetting: {maxScrollbarLength: 350},
      form: {
        flowName: null,
        flowCode: null,
        flowTypeName: null,
        deptName: null,
        note: null,
        isDefault: null,
        status: null,
        // hideVtComments: null
      }
    };
  },

  computed: {
    isIncomingFlow() {
      return this.vbFlowForm.flowType === constants.FLOW_TYPE.VB_DEN;
    }
  },

  created() {
    this.initComponent();
  },

  methods: {
    submit() {
      this.$emit("submit");
    },

    editVbFlowForm() {
      this.$emit("editVbFlowForm");
    },

    initComponent() {
      this.bindDataToForm();
    },

    getDepartmentName(deptId) {
      return departmentService
        .findById(deptId)
        .then(response => response.data)
        .then(department => (department ? department.deptName : null));
    },

    async bindDataToForm() {
      this.form.flowName = this.vbFlowForm.flowName;
      this.form.flowCode = this.vbFlowForm.flowCode;
      this.form.flowTypeName = cauHinhLuongUtils.getFlowTypeName(
        this.vbFlowForm.flowType
      );
      await this.getDepartmentName(this.vbFlowForm.deptId).then(
        deptName => (this.form.deptName = deptName || "-")
      );
      this.form.note = this.vbFlowForm.note;
      this.form.isDefault = this.vbFlowForm.isDefault === constants.TRUE;
      this.form.status = this.vbFlowForm.status === constants.STATUS_.ACTIVE;
      // this.form.hideVtComments =
      //   this.vbFlowForm.hideVtComments === constants.TRUE;
    },

    modelBack() {
      this.$router.replace({name: "CauHinhLuong"});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/setting/cau-hinh-luong-v2/vb-flow-detail-panel.vue